
import React from 'react';
import Layout from '@/components/Layout/Layout';
import MortgageCalculator from '@/components/SpecialCalculators/MortgageCalculator';
import { Link } from 'react-router-dom';

const MortgageCalculatorPage = () => {
  return (
    <Layout>
      <div className="max-w-5xl mx-auto px-4">
        {/* Header Section */}
        <div className="mb-8">
          <div className="text-sm text-gray-500 mb-2">
            <Link to="/" className="hover:underline">Home</Link> {' > '} 
            <Link to="/special" className="hover:underline">Special Tools</Link> {' > '} 
            <span>Mortgage Calculator</span>
          </div>
          <h1 className="text-3xl font-bold mb-3">Mortgage Calculator</h1>
          <p className="text-gray-700">
            Calculate your estimated monthly mortgage payments, see the amortization schedule, and determine how much house you can afford.
          </p>
        </div>

        {/* Calculator Section */}
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200 mb-8">
          <MortgageCalculator />
        </div>

        {/* Information Section */}
        <div className="bg-[#E6F3FF] p-6 rounded-lg mb-8">
          <h2 className="text-2xl font-semibold mb-3">How to use the Mortgage Calculator</h2>
          <ol className="list-decimal list-inside space-y-2 text-gray-700 ml-2">
            <li>Enter the home value</li>
            <li>Adjust the down payment amount or percentage</li>
            <li>Enter your interest rate</li>
            <li>Select your loan term</li>
            <li>Choose your payment frequency</li>
            <li>The calculator will automatically show your monthly payment, total payments, and total interest</li>
          </ol>
        </div>

        {/* Additional Information */}
        <div className="mb-8">
          <h2 className="text-2xl font-semibold mb-3">About Mortgage Calculations</h2>
          <p className="text-gray-700 mb-3">
            A mortgage is a loan secured by property, typically a house. Mortgage calculators help estimate the monthly 
            payments on your home loan, including principal and interest. Our calculator can also show you how much you'll 
            pay in total interest over the life of your loan.
          </p>
          <p className="text-gray-700 mb-3">
            The down payment is the upfront amount you pay, which reduces the loan amount needed. Typically, a higher down 
            payment results in better interest rates and avoids private mortgage insurance requirements.
          </p>
          <p className="text-gray-700 mb-3">
            Adjusting the loan term affects your monthly payments and total interest paid. Shorter loan terms mean higher 
            monthly payments but less interest paid overall, while longer terms result in lower monthly payments but more 
            total interest.
          </p>
        </div>

        {/* Related Calculators */}
        <div className="mb-8">
          <h2 className="text-2xl font-semibold mb-3">Related Calculators</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
            <Link to="/special/loan" className="p-4 border border-gray-200 rounded-md hover:bg-gray-50 flex items-center">
              <span className="text-xl mr-2">💰</span> Loan Calculator
            </Link>
            <Link to="/special/bmi" className="p-4 border border-gray-200 rounded-md hover:bg-gray-50 flex items-center">
              <span className="text-xl mr-2">⚖️</span> BMI Calculator
            </Link>
            <Link to="/special/tip" className="p-4 border border-gray-200 rounded-md hover:bg-gray-50 flex items-center">
              <span className="text-xl mr-2">🍽️</span> Tip Calculator
            </Link>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default MortgageCalculatorPage;
